import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1aa7a521")

_pushScopeId("data-v-1aa7a521")
const _hoisted_1 = { id: "entire_app__ticket_booking" }
const _hoisted_2 = { class: "ticket_booking_navigation" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createVNode("h3", null, "Booking your journey")
], -1)
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = { class: "ticket_booking_content col-mob-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_booking_details = _resolveComponent("booking-details")
  const _component_booking_payment = _resolveComponent("booking-payment")
  const _component_booking_scan = _resolveComponent("booking-scan")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          class: ["menu_item", {'--menu_item': _ctx.$store.state.Booking.isBookingDetails}]
        }, [
          _createVNode("p", {
            class: {'--book_menu_p': _ctx.$store.state.Booking.isBookingDetails}
          }, "Booking", 2)
        ], 2),
        _createVNode("div", {
          class: ["menu_item_link", {'--menu_item_link': _ctx.$store.state.Booking.isBookingPayment}]
        }, null, 2),
        _createVNode("div", {
          class: ["menu_item", {'--menu_item': _ctx.$store.state.Booking.isBookingPayment}]
        }, [
          _createVNode("p", {
            class: {'--book_menu_p': _ctx.$store.state.Booking.isBookingPayment}
          }, "Payment", 2)
        ], 2),
        _createVNode("div", {
          class: ["menu_item_link", {'--menu_item_link': _ctx.$store.state.Booking.isBookingComplete}]
        }, null, 2),
        _createVNode("div", {
          class: ["menu_item", {'--menu_item': _ctx.$store.state.Booking.isBookingComplete}]
        }, [
          _createVNode("p", {
            class: {'--book_menu_p': _ctx.$store.state.Booking.isBookingComplete}
          }, "Scanning", 2)
        ], 2)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives(_createVNode(_component_booking_details, null, null, 512), [
        [_vShow, _ctx.$store.state.Booking.showTicketDetails 
                && !_ctx.$store.state.Booking.showPayment 
                && !_ctx.$store.state.Booking.showScanStage]
      ]),
      _withDirectives(_createVNode(_component_booking_payment, null, null, 512), [
        [_vShow, !_ctx.$store.state.Booking.showTicketDetails 
                && _ctx.$store.state.Booking.showPayment 
                && !_ctx.$store.state.Booking.showScanStage]
      ]),
      _withDirectives(_createVNode(_component_booking_scan, null, null, 512), [
        [_vShow, !_ctx.$store.state.Booking.showTicketDetails 
                && !_ctx.$store.state.Booking.showPayment 
                && _ctx.$store.state.Booking.showScanStage]
      ])
    ])
  ]))
})